"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.round = void 0;
/**
 * To ensure a crisp image, coordinates used in canvas operations should be rounded to
 * whole pixels as much as possible. "1.231px" vs "1px" makes a massive difference in
 * sharpness, especially for pictures with logos or text.
 *
 * Always round at the very last moment, at the {@code ctx} method call. Avoid rounding
 * intermediate values as that causes inconsistency and jumps.
 */
function round(objectOrEnabledFlag, n) {
    var enabled = typeof objectOrEnabledFlag === "object"
        ? objectOrEnabledFlag.round
        : objectOrEnabledFlag;
    return enabled ? Math.round(n) : n;
}
exports.round = round;
//# sourceMappingURL=round.js.map